import * as fromParametrosGenerales from './parametrosgenerales.accions'
import { ParametrosGenerales } from '../../../../models/parametrosgenerales/parametrosgenerales.models';

export interface ParametrosGeneralesState {
    parametrosGenerales: ParametrosGenerales
}

const initState: ParametrosGeneralesState = {
    parametrosGenerales: null
};
export function parametrosGeneralesReducer( state = initState, action: fromParametrosGenerales.acciones): ParametrosGeneralesState {
    switch ( action.type) {
        case fromParametrosGenerales.SET_PARAMETROSGENERALES:
            return {
                parametrosGenerales: {...action.parametrosGenerales}
            };
        case fromParametrosGenerales.UNSET_PARAMETROSGENERALES:
            return {
                parametrosGenerales: null
            };
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/pages/parametros-generales/state/parametrosgenerales/parametrosgenerales.reducer.ts